module.exports = __webpack_public_path__ + "static/media/trademark_assigment.7f095783.png";